import { Component, Input } from '@angular/core';
import { DocumentationStatus } from './model/documentation-status.model';

@Component({
    selector: 'app-documentation-status-list',
    templateUrl: './documentation-status-list.component.html',
    styles: [],
})
export class DocumentationStatusListComponent {
    @Input() statuses: DocumentationStatus[] = [];
}
